import md5 from 'js-md5';

// 定义移动端
export function _isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return flag;
}

// 密码加密
export function encryption(pwd) {
    return md5(md5(pwd) + process.env.VUE_APP_PASSWORD_SALT);
}

// 请求header头加密
export function headerEncryption(time) {
    return md5(process.env.VUE_APP_HEADER_KEY + time)
}